import React from 'react'

import { DefaultLayout } from '~/layouts'
import Label from '~/truck/label'

import { Content } from './elements'
import Zones from './zones'

const CoverageScreen = () => {
  return (
    <DefaultLayout>
      <Label as="p" $textStyle="h4Semibold" style={{ flexShrink: 0 }}>
        Nuestra cobertura
      </Label>
      <Content>
        <Zones />
      </Content>
    </DefaultLayout>
  )
}

export default CoverageScreen
